<div class="grid-container margin-top">
    <router-outlet></router-outlet>
</div>